var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-ss-c-checkbox",class:{
        'l-ss-c-checkbox-disabled': _vm.disabled,
        'l-ss-c-checkbox-checked': _vm.isChecked
    }},[_c('label',[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', { event: $event, value: !_vm.value })}}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }